export const eMobilityPalette = {
  activeBackground: '#ffffff',
  inactiveBackground: '#F7F7F7',
  hoverBorder: '#4a4a4a',
  activeBorder: '#00477e',
  inactiveBorder: '#e6e6e6',
  activeText: '#00477e',
  inactiveText: '#4a4a4a',
  searchFieldBackground: '#F7F7F7',
  menuItemHoverBackground: 'rgba(0, 170, 225, 0.08)',
  selectedMenuItemHoverBackground: 'rgba(0, 170, 225, 0.12)',
}
